export enum ContactType {
  Supplier = 'Supplier',
  Customer = 'Customer',
}
